var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-dashboard-students-wrapper",
    },
    [
      _c("CoursewareRibbon", {
        attrs: {
          isContentBar: true,
          showToolbarButton: false,
        },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function fn() {
              return [
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "task-groups-index",
                      },
                    },
                  },
                  [
                    _c("StudipIcon", {
                      attrs: {
                        shape: "category-task",
                        size: 24,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "breadcrumbList",
            fn: function fn() {
              return [
                _c("li", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Aufgaben")) +
                      "\n            "
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.taskGroups.length
        ? _c(
            "table",
            {
              staticClass: "default",
            },
            [
              _c("thead", [
                _c(
                  "tr",
                  {
                    staticClass: "sortable",
                  },
                  [
                    _c("th", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$gettext("Status")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        class: _vm.getSortClass("task-group-title"),
                        on: {
                          click: function click($event) {
                            return _vm.sort("task-group-title")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Titel")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        class: _vm.getSortClass("end-date"),
                        on: {
                          click: function click($event) {
                            return _vm.sort("end-date")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$gettext("Bearbeitungszeit")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "th",
                      {
                        staticClass: "actions",
                      },
                      [_vm._v(_vm._s(_vm.$gettext("Aktionen")))]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.sortedTaskGroups, function (taskGroup, index) {
                  return _c(
                    "tr",
                    {
                      key: index,
                    },
                    [
                      _c(
                        "td",
                        [
                          _c("StudipIcon", {
                            attrs: {
                              shape: _vm.status(taskGroup).shape,
                              role: _vm.status(taskGroup).role,
                              title: _vm.status(taskGroup).description,
                              "aria-hidden": "true",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "sr-only",
                            },
                            [_vm._v(_vm._s(_vm.status(taskGroup).description))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "task-groups-show",
                                  params: {
                                    id: taskGroup.id,
                                  },
                                },
                              },
                            },
                            [_vm._v(_vm._s(taskGroup.attributes.title))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("StudipDate", {
                            attrs: {
                              date: new Date(
                                taskGroup.attributes["start-date"]
                              ),
                            },
                          }),
                          _vm._v(" - "),
                          _c("StudipDate", {
                            attrs: {
                              date: new Date(taskGroup.attributes["end-date"]),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "actions",
                        },
                        [
                          _c("StudipActionMenu", {
                            attrs: {
                              items: _vm.getTaskGroupMenuItems(taskGroup),
                            },
                            on: {
                              addsolvers: function addsolvers($event) {
                                return _vm.onShowAddSolvers(taskGroup)
                              },
                              deadline: function deadline($event) {
                                return _vm.onShowModifyDeadline(taskGroup)
                              },
                              delete: function _delete($event) {
                                return _vm.onShowDeleteDialog(taskGroup)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : !_vm.tasksLoading
        ? _c("CompanionBox", {
            attrs: {
              msgCompanion: _vm.$gettext(
                "Es wurden noch keine Aufgaben verteilt."
              ),
            },
            scopedSlots: _vm._u([
              {
                key: "companionActions",
                fn: function fn() {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: {
                          type: "button",
                        },
                        on: {
                          click: function click($event) {
                            return _vm.setShowTasksDistributeDialog(true)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                " +
                            _vm._s(_vm.$gettext("Aufgabe verteilen")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskGroupsAddSolversDialog
        ? _c("TaskGroupsAddSolversDialog", {
            attrs: {
              taskGroup: _vm.selectedTaskGroup,
            },
            on: {
              newtask: _vm.reloadTasks,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskGroupsDeleteDialog
        ? _c("TaskGroupsDeleteDialog", {
            attrs: {
              taskGroup: _vm.selectedTaskGroup,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTaskGroupsModifyDeadlineDialog
        ? _c("TaskGroupsModifyDeadlineDialog", {
            attrs: {
              taskGroup: _vm.selectedTaskGroup,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showTasksDistributeDialog
        ? _c("CoursewareTasksDialogDistribute", {
            on: {
              newtask: _vm.reloadTasks,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }